module.exports = __webpack_public_path__ + "static/media/heart.4e01da79.svg";